import {Box} from '@mui/material'
import {FC, ReactNode} from 'react'

import useIsDesktop from '../hooks/useIsDesktop'
import theme from '../theme'

const TabPanel: FC<TabPanelProps> = ({
  children, isSelected, value, ...otherProps
}) => {
  const isDesktop = useIsDesktop()
  return (
    <div
      aria-labelledby={`full-width-tab-${value}`}
      dir={theme.direction}
      hidden={!isSelected}
      id={`full-width-tabpanel-${value}`}
      role="tabpanel"
      {...otherProps}
    >
      {isSelected && (<Box p={isDesktop ? 3 : 0}>{children}</Box>)}
    </div>
  )
}

interface TabPanelProps {
  [key: string]: unknown
  children: ReactNode
  isSelected: boolean
  value: number | string
}

export default TabPanel
